<!--
 * @Author: zhengyi yi.zheng@yunzhihulian.cn
 * @Date: 2023-06-27 18:46:04
 * @LastEditors: zhengyi yi.zheng@yunzhihulian.cn
 * @LastEditTime: 2023-11-03 09:49:40
 * @FilePath: \whds-new-front-web\src\pages\securityCenter\default\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 侧边栏 -->
    <sider-list ref="side"></sider-list>
    <!-- 右侧主要内容 -->
    <div class="home-content " id="home-content" ref="content">
      <router-view></router-view>
    </div>
    <div class="maskConAgreement pa pr" v-if="isShowAgreement">
      <agreementCom ref="agreementCom" class="agreementCon" :type="id" @suerAgree="suerAgree">
      </agreementCom>
    </div>
  </div>
</template>

<script>
// 左侧侧边栏
import SiderList from './siderList';
import agreementCom from '../../download/agreement.vue';
import { agreementSecurity, queryAgreementSecurity } from '../../../requests/agreement'
export default {
  name: 'securityCenter',
  components: {
    SiderList,
    agreementCom
  },
  data () {
    return {
      isShowAgreement: false,
      id:3
    }
  },
  mounted () {
    this.queryAgreementSecurity()
    //this.$refs.agreementCom.isShowTxt = true
  },
  methods: {
    async queryAgreementSecurity () {
      let res = await queryAgreementSecurity({
        id: this.id
      })
      if (res.code == 200) {
        if (res.data != 1) {
          this.isShowAgreement = true
          setTimeout(() => {
            this.$refs.agreementCom.isShowTxt = true
          }, 10);
        }
      }
    },
    suerAgree () {
      // this.isShowAgreement = false
      this.agreementSecurity()
    },
    async agreementSecurity () {
      let res = await agreementSecurity({
        id: this.id
      })
      if (res.code == 200) {
        this.isShowAgreement = false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.maskCon {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: .5);
  z-index: 99999;
  left: 0;
  top: 0;
}

.home-content {
  position: absolute;
  min-width: 1180px;
  left: 200px;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
}

// style="position: absolute;min-width: 1180px;left: 200px;right: 0;top: 0;bottom: 0;overflow: auto;"
// style="position: absolute;min-width: 1100px;left: 200px;right: 0;top: 0;bottom: 0;overflow: auto;"
</style>
<style lang="scss">
.maskConAgreement {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: .5);
  z-index: 99999;
  left: 0;
  top: 0;

  .closeBtn {
    display: none;
  }

  .agreementCon {
    width: 770px;
    height: 600px;
    .WordSection1{
      
    width: 700px;
    }
    .MsoNormal {
      width: 730px;
    }

    h4 {
      width: 800px !important;
    }

    .inCon {
      height: 500px !important;
    }
  }
}
</style>